export default {
    "en": {
        "kollus_player": {
            "media_result": {
                "http_status_code": {
                    "0": "This video not supported by your device.",
                    "404": "Video not found.",
                    "461": "Invalid request.",
                    "462": "IP Address unrecornizable.",
                    "463": "Video not found.",
                    "464": "Server error. Please try again.",
                    "465": "Invalid media key.",
                    "466": "Request blocked.",
                    "467": "Media key expired.",
                    "468": "Invalid content domain.",
                    "469": "Server error. Please try again.",
                    "470": "Payment error.",
                    "471": "Content blocked from requested region.",
                    "472": "Pre-view failed.",
                    "473": "Invalid user key.",
                    "474": "Not public video.",
                    "475": "Media key expired.",
                    "476": "Media key length exceeded.",
                    "477": "Invalid request.",
                    "478": "Server error. Please try again.",
                    "479": "Request blocked.",
                    "480": "Unauthorized Access.",
                    "481": "Server error. Please try again.",
                    "482": "Server error. Please try again."
                }
            },
            "notify_message": {
                "mac": {
                    "install_guide": "Kollus Mac Player must be installed to watch this video.<br />Press [Download] button to install.<br />(Compatible only with Mac OS/X 10.9 Mavericks or later)",
                    "install_button": "Download"
                },
                "mobile": {
                    "install_guide": "Go to the store to download Kollus Player app.<br />Touch this message box to close.",
                    "install_button": "Move to app store"
                },
                "flash": {
                    "install_guide": "Click to play Adobe Flash Player."
                },
                "not_supported_browser": "Videos cannot be played on Internet Explorer. Please use the Chrome browser.",
                "jwt_expired_time": "Available period to play this content is expired. Please try again.",
                "not_supported_html5_video": "This video can be played on the Kollus player. <br />Please wait for a while."
            }
        }
    },
    "ja": {
        "kollus_player": {
            "media_result": {
                "http_status_code": {
                    "0": "この動画はお使いの端末でサポートされていません。",
                    "404": "存在しないコンテンツです。",
                    "461": "URLが正しくありません。",
                    "462": "ユーザーIPの確認ができません。",
                    "463": "存在しないコンテンツです。",
                    "464": "サーバーにエラーが発生しました。しばらくしてから再度アクセスしてください。",
                    "465": "メディア キーのエラーが発生しました。",
                    "466": "リクエストしたコンテンツがブロックされました。",
                    "467": "無効なメディア キーです。",
                    "468": "メディアのURLが正しくありません。",
                    "469": "サーバの負荷が高いです。\nしばらくしてから再度アクセスしてください。",
                    "470": "課金エラーが発生しました。",
                    "471": "この国では再生がブロックされたコンテンツです。",
                    "472": "プレビューに失敗しました。",
                    "473": "ユーザー キーのエラーが発生しました。",
                    "474": "非公開コンテンツです。",
                    "475": "使用中のメディア キーです。",
                    "476": "認証確認リクエストの長さ制限を超過しました。",
                    "477": "キーが異なります。",
                    "478": "サーバーに接続できません。\nしばらくしてから再度アクセスしてください。",
                    "479": "重複再生がブロックされたコンテンツです。\nコンテンツ提供社に連絡して端末登録/解除行ってから再度試してください。",
                    "480": "正しくないアクセスです。",
                    "481": "サーバーにエラーが発生しました。しばらくしてから再度アクセスしてください。",
                    "482": "サーバーにエラーが発生しました。しばらくしてから再度アクセスしてください。"
                }
            },
            "notify_message": {
                "mac": {
                    "install_guide": "再生のためにはMac専用プレーヤーをインストールする必要があります。<br />プレーヤーがインストールされてない場合、ダウンロードボタンをクリックしてください。<br />(Mac OS/X 10.9 Mavericks以上のバージョンでインストール可能です。)",
                    "install_button": "ダウンロード"
                },
                "mobile": {
                    "install_guide": "Kollus Playerがインストールされていない場合にはApp storeを開いてください。<br />タップしてこのメッセージを閉じます。",
                    "install_button": "Move to app store"
                },
                "flash": {
                    "install_guide": "Click to play Adobe Flash Player."
                },
                "not_supported_browser": "Internet Explorerではビデオを再生できません。Chromeブラウザをご利用ください。",
                "jwt_expired_time": "再生有効時間が過ぎています。再度アクセスしてください。",
                "not_supported_html5_video": "このコンテンツは専用プレーヤーで再生されます。<br />しばらくお待ちください。"
            }
        }
    },
    "ko": {
        "kollus_player": {
            "media_result": {
                "http_status_code": {
                    "0": "이 동영상은 현재 기기에서 재생할 수 없습니다.",
                    "404": "컨텐츠가 존재하지 않습니다.",
                    "461": "알 수 없는 형식의 URL입니다.",
                    "462": "사용자의 IP를 확인할 수 없습니다.",
                    "463": "컨텐츠가 존재하지 않습니다.",
                    "464": "서버 오류가 발생했습니다. 잠시 후 재시도 해 주세요.",
                    "465": "미디어 키 오류가 발생했습니다.",
                    "466": "요청한 컨텐츠가 차단되었습니다.",
                    "467": "미디어 키 유효기간이 만료되었습니다.",
                    "468": "미디어 도메인이 정확하지 않습니다.",
                    "469": "서버 과부하가 발생했습니다. 잠시 후 재시도 해 주세요.",
                    "470": "과금 오류가 발생했습니다.",
                    "471": "해당 국가에서 재생할 수 없는 컨텐츠입니다.",
                    "472": "미리보기가 실패했습니다.",
                    "473": "사용자 키 오류가 발생했습니다.",
                    "474": "공개 컨텐츠가 아닙니다.",
                    "475": "미디어 키가 사용중 입니다.",
                    "476": "인증 확인 최대 Request 길이를 초과했습니다.",
                    "477": "비정상적인 요청입니다.",
                    "478": "서버 오류가 발생했습니다. 잠시 후 재시도 해 주세요.",
                    "479": "중복 차단된 컨텐츠입니다. 컨텐츠 제공업체 홈페이지에서 기기등록 해제 신청 후 재시도 해주세요.",
                    "480": "정상적인 접근 경로가 아닙니다.",
                    "481": "서버 오류가 발생했습니다. 잠시 후 재시도 해 주세요.",
                    "482": "서버 오류가 발생했습니다. 잠시 후 재시도 해 주세요."
                }
            },
            "notify_message": {
                "mac": {
                    "install_guide": "Mac 전용 플레이어를 통해 영상이 재생됩니다.<br />플레이어가 설치되지 않았을 경우 아래 버튼을 눌러주세요.<br />(Mac OS/X 10.9 매버릭스 이상에서만 설치 가능)",
                    "install_button": "다운로드"
                },
                "mobile": {
                    "install_guide": "플레이어 설치가 안되어 있는경우에는 스토어로 이동해주세요.<br />본 메시지창을 터치할 경우 사라집니다.",
                    "install_button": "스토어 이동"
                },
                "flash": {
                    "install_guide": "Adobe Flash Player를 사용하려면 클릭하세요."
                },
                "not_supported_browser": "인터넷 익스플로러에서는 비디오를 재생할 수 없습니다. 크롬 브라우저를 이용해주세요.",
                "jwt_expired_time": "재생 가능한 유효시간이 지났습니다. 다시 시도하여 주시기 바랍니다.",
                "not_supported_html5_video": "본 컨텐츠는 전용 플레이어를 통해 재생됩니다.<br />잠시만 기다려주세요."
            }
        }
    }
}
